import './listing-photo.css';
import { IListingPhoto } from '../../models/listing-photo.model';

export const ListingPhoto = (props: IListingPhoto) => {

  if (props.url === undefined || props.url === "") {
    return <div />
  }

  return <img loading="lazy" className="listing-photo" src={props.url} alt={props.description} title={props.description} />
}
